import React from 'react';

/**
 * ProgressBar — thin horizontal progress track. `value`/`max`, optional tone.
 */
export function ProgressBar({ value = 0, max = 100, tone = 'green', height = 8, style = {}, ...rest }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const colors = { green: 'var(--brand-green)', amber: 'var(--status-pending)', red: 'var(--status-overdue)', blue: 'var(--accent-blue)' };
  return (
    <div style={{ width: '100%', height, borderRadius: 999, background: 'var(--surface-2)', overflow: 'hidden', ...style }} {...rest}>
      <div style={{ width: `${pct}%`, height: '100%', borderRadius: 999, background: colors[tone] || colors.green, transition: 'width .3s ease' }} />
    </div>
  );
}
